<template>
  <IQOS :title="$t('worker_profile.profile_title')" :enabled="editing" required>
    <div class="profile-row mt-16">
      <div class="profile-image" :class="{
        editing
      }">
        <img :src="edit_fields.photo || '/icons/worker-profile-placeholder.png'">
        <IQOSImageActions fillSpace class="mt-8" v-model="edit_fields.photo" v-if="editing"/>
      </div>
      <div class="profile-info ml-16">
        <BaseInput
          fullWidth
          v-model="edit_fields.name"
          :placeholder="$t('workers_table.col_name')"
          :disabled="!editing"
          :valid="valid || !!edit_fields.name"
        />
        <BaseInput
          v-model="edit_fields.pin"
          fullWidth
          :placeholder="$t('workers_table.col_pin')"
          mask="####"
          class="mt-8"
          :disabled="!editing"
          :valid="valid || !!edit_fields.pin"
        />
        <BaseInput
          fullWidth
          v-model="edit_fields.phone"
          class="mt-8"
          :placeholder="$t('worker_profile.phone_ph')"
          :disabled="!editing"
        />
      </div>
    </div>

    <template #actions>
      <IQOSActions
        :editing="editing"
        @edit="showEditUI"
        @cancel="hideEditUI"
        @accept="onEditFinish"
      />
    </template>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import BlackInput from "@/components/BlackInput.vue";
import IQOSActions from "@/components/IQOSActions.vue";

export default {
  props: {
    waiter: Object,
  },
  data() {
    return {
      edit_fields: {},
      editing: false,

      valid: true,
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    reset() {
      this.edit_fields = Object.assign({}, this.waiter);
    },
    onEditFinish() {
      if (!this.edit_fields.name || !this.edit_fields.pin) {
        this.valid = false;
        return;
      }
      this.valid = true;

      this.$emit("saved", this.edit_fields);
      // this.editing = false;
    },
    markSaved() {
      this.editing = false;
    },
  },
  mounted() {
    this.reset();

    if (!this.waiter.name) this.showEditUI();
  },
  components: {
    IQOS,
    IQOSActions,
    BlackInput,
  },
};
</script>

<style scoped>

.profile-row {
  display: flex;
}

.profile-info {
  width: 100%;
}

.profile-image.editing img {
  min-width: 80px;
  max-width: 80px;
  min-height: 80px;
  max-height: 80px;
  display: block; 
}

.profile-image img {
  min-width: 112px;
  max-width: 112px;
  min-height: 112px;
  max-height: 112px; 

  border-radius: 4px;
  display: block;
}
</style>
